import { DOCS_FORM_NAMES } from "core/consts";
import type { PdfCreatorProps } from "../..";
import { FieldConfig, createDischargeLetterPdf } from "../pdfCreationUtils";

export const ACCIDENT_SURGERY_FIELD_CONFIG: Array<
  FieldConfig<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_TRAUMA_SURGERY>
> = [
  {
    key: "main_diagnosis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery.diagnosisLabel,
  },
  {
    key: "secondary_diagnosis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery
        .secondaryDiagnosisLabel,
  },
  {
    key: "therapy",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery.therapyLabel,
  },
  {
    key: "imaging",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery.imagingLabel,
  },
  {
    key: "lab_results",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery.labResultsLabel,
  },
  {
    key: "medication_upon_discharge",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery
        .dischargeMedicationLabel,
  },
  {
    key: "epicrisis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery.epicrisisLabel,
  },
  {
    key: "discharge_recommendations",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery
        .dischargeRecommendationLabel,
  },
];

export function createAccidentSurgeryDischargeLetterPdf(
  props: PdfCreatorProps<
    typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_TRAUMA_SURGERY
  >,
) {
  return createDischargeLetterPdf<
    typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_TRAUMA_SURGERY
  >(props, ACCIDENT_SURGERY_FIELD_CONFIG);
}
